<div class="jp-custom-pagination">
  <div class="jp-items-per-page">
    <span>Rows per page:</span>
    <select
      class="jp-pagi-select"
      [(ngModel)]="selected"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="pageChange($event)"
    >
      <option *ngFor="let item of page" [value]="item">{{ item }}</option>
    </select>
  </div>

  <div class="jp-pagination-info">
    {{ from }} – {{ to }} of {{ totalCount }}
  </div>

  <div class="jp-pagination-actions">
    <button
      class="jp-pagi-btn"
      (click)="OverDecrement()"
      [disabled]="pageIndex === 1"
      title="First Page"
    >
      <i>«</i>
    </button>
    <button
      class="jp-pagi-btn"
      (click)="decrement()"
      [disabled]="pageIndex === 1"
      title="Previous Page"
    >
      <i>‹</i>
    </button>
    <button
      class="jp-pagi-btn"
      (click)="increment()"
      [disabled]="to === totalCount"
      title="Next Page"
    >
      <i>›</i>
    </button>
    <button
      class="jp-pagi-btn"
      (click)="overIncrement()"
      [disabled]="to === totalCount"
      title="Last Page"
    >
      <i>»</i>
    </button>
  </div>
</div>
